import { render, staticRenderFns } from "./DeviceInfo.vue?vue&type=template&id=1236d2cf&"
import script from "./DeviceInfo.vue?vue&type=script&lang=js&"
export * from "./DeviceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports